<template>


  <div class="recommend">
    <div class="tab-box" ref="tab" v-if="tabs && tabs.length">
      <h2 class="title">
        <span></span>
      </h2>
      <div class="tab" v-if="tabs && tabs.length > 1">
        <span v-for="(text, index) in tabs" :key="index" @click="swichTab(index)" :class="{'on':index === tabCurrent}">{{text.title}}</span>
      </div>
    </div>
    <div class="fixed-bar" v-if="showTopFix && tabs && tabs.length > 1" ref="fixedbar">
       <span v-for="(text, index) in tabs" :key="index" @click="swichTab(index)" :class="{'on':index === tabCurrent}">{{text.title}}</span>
    </div>

    <mt-loadmore ref="loadmore" class="loadmore-box">
      <goods-list :goodsList="goodsList" :shopId="shopId" :tabCurrent="tabCurrent" :tabName="tabs[tabCurrent] && tabs[tabCurrent].title"></goods-list>

    </mt-loadmore>
    <div class="b-coupon" v-if="coupon && coupon.needShowed" @click="clickCoupon">
      <span class="coupon-price">{{coupon.value}}元</span>
      <span class="coupon-time" v-if="timeObj">
          <span>{{timeObj.hour >= 10 ? timeObj.hour : '0' + timeObj.hour}}</span><i>:</i>
          <span>{{timeObj.minutes >= 10 ? timeObj.minutes : '0' + timeObj.minutes}}</span> <i>:</i>
          <span>{{timeObj.seconds >= 10 ? timeObj.seconds : '0' + timeObj.seconds}}</span><br />后失效
      </span>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Loadmore } from 'mint-ui'
import GoodsList from './GoodsListAppletB.vue'
import YunJi from '@/assets/js/YunJi'
import * as Http from '@/pages/commodity/api/share'
import { Toast } from 'mint-ui';
import * as Util from '@/assets/js/Util'

Vue.component(Loadmore.name, Loadmore)

export default {
  data() {
    return {
      tabs: [],
      tabCurrent: 0,
      goodsList: [],
      appCont: YunJi.getUrlParams('appCont') || 0, // 客户端标识 0-H5，1-卖家版，2-买家版
      shopId: YunJi.getUrlParams('shopId'), // 店铺id
      page: {
        pageIndex: 0,
        pageSize: 18
      },
      isLoading: false,
      showTopFix: false,
      noMore: false,
      coupon: null,
      timeObj: null,
      timer: null,
      ABtestId: YunJi.getUrlParams('ABtestId') || ''
    }
  },
  components: {
    GoodsList
  },
  destroyed() {
    this.timer = null
  },
  methods: {
    /**
     * 获取推荐商品
     */
    getAiGoodsList() {
      let that = this
      if (this.page.pageIndex) {
        this.isLoading = true
      }
      Http.queryNavigationItemListB({
        subjectId: that.tabs[that.tabCurrent] && that.tabs[that.tabCurrent].subjectId,
        resourceType: that.tabs[that.tabCurrent] && that.tabs[that.tabCurrent].resourceType || '',
        resourceId: that.tabs[that.tabCurrent] && that.tabs[that.tabCurrent].resourceId || '',
        appCont: that.appCont
      }).then((res) => {
        this.isLoading = false
        if (res.errorCode == 0 && res.data) {
          const tempList = res.data || []
          this.goodsList.push(...tempList)
          this.page.pageIndex += 1
          if (tempList.length < this.page.pageSize) {
            this.noMore = true
          }
          let ids = Util.exposureThinkingReport()
          let params = {
            ids: ids.join(','),
            tabName: that.tabs[that.tabCurrent].title
          }
          ids && wx.miniProgram && wx.miniProgram.postMessage({data: JSON.stringify(params)})
        }
      })
    },
    /**
     * 刷新推荐商品列表
     */
    initRecommendGoodsList(){
      this.goodsList = [];
      this.tabCurrent = 0;
      this.getAiGoodsList();
    },
    swichTab(index) {
      this.tabCurrent = index
      this.initList()
      let name = this.tabs[index].title
      window.thinkingReport.track('click_list', {
        page_id: '80612',
        point_id: '26438',
        tab_name: name,
        'ABtestId': this.ABtestId
      })
      console.log(index)
    },
    initList() {
      this.goodsList = []
      this.noMore = false
      this.page = {
        pageIndex: 0,
        pageSize: 18
      }
      setTimeout(() => {
        this.getAiGoodsList()
      }, 50)
    },

    resetTime() {
      let end_time = this.coupon.expireTime;
      let now_time = new Date().getTime();

      let resetSec = end_time - now_time;

      let day = parseInt(resetSec/(60*60*24*1000));
      let hour = parseInt(resetSec/(60*60*1000)%24);
      let minu = parseInt(resetSec/(60*1000)%60);
      let sec = parseInt(resetSec/1000%60);
      this.coupon.expireTime = `${day * 24 + hour}:${minu}:${sec}`
    },
    countDown(endTime) {
      let date = endTime - new Date().getTime() // 时间差
      let mmsec = date % 1000 // 所余毫秒数
      let seconds = Math.floor(date / 1000 % 60) // 所余秒
      let minutes = Math.floor(date / 1000 / 60 % 60) // 所余分钟数
      let hour = Math.floor(date / 1000 / 60 / 60 % 24) // 所余时钟数
      let day = Math.floor(date / 1000 / 60 / 60 / 24) // 天数
      this.timeObj = {
        hour: hour + day * 24,
        minutes: minutes,
        seconds: seconds,
        mmsec: Math.ceil(mmsec / 100)
      }
      if (!+this.timeObj.hour && !+this.timeObj.minutes && !+this.timeObj.seconds) {
        this.timer = null
        this.coupon.needShowed = false
      }
    },
    clickCoupon() {
      Toast('云币/优惠券即将失效，快去使用吧')
    },
    queryCouponFunc(){
      let that = this
      Http.queryCoupon({
        appCont: that.appCont
      }).then((res) => {
        if (res.errorCode == 0 && res.data) {
          that.coupon = res.data
          // that.resetTime()
          // that.coupon.needShowed = true
          if (res.data.needShowed) {
            that.timer = setInterval(() => {
              that.countDown(res.data.expireTime || new Date().getTime()) // 只需要传入结束时间
            }, 1000)
          }
          
        }
      })
    }
  },
  mounted() {
    let that = this
    Http.queryResourcebit({
      resourceBitKey: 'shareCloud',
      appCont: that.appCont
    }).then((res) => {
      if (res.errorCode == 0 && res.data) {
        that.tabs = res.data.resourceBitConfigs.slice(0, 3)
        that.getAiGoodsList()
      }
    })
    this.queryCouponFunc()
    let scrollTimer = null

    // console.log("goodsList", this.goodsList);
    window.onscroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 110
      // 230
      const startPos = YunJi.remToPx(2.26)
      if (scrollTop > this.$refs.tab.offsetTop + startPos) {
        this.showTopFix = true
        // this.$refs.topbar.style.opacity = (scrollTop - startPos) / 12 * 0.1
      } else {
        this.showTopFix = false
      }
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        let ids = Util.exposureThinkingReport()
        let params = {
          ids: ids.join(','),
          tabName: that.tabs[that.tabCurrent].title
        }
        ids && wx.miniProgram && wx.miniProgram.postMessage({data: JSON.stringify(params)})
      }, 300);
    }
  }
}
</script>
<style lang="less" scoped>
.recommend{
  .tab-box {
    width: 7rem;
    background: #fff;
    margin:0 auto;
    border-radius: 0.12rem;
    margin-bottom: .2rem;
    .title {
      text-align: center;
      padding: 0.36rem 0.48rem;
      span {
        display: inline-block;
        width: 5.86rem;
        height: 0.4rem;
        background: url('../image/recommend-title.png') no-repeat; 
        background-size: 100% 100%;  
              
      }

      
    }   
    .tab {
      font-size: 0;
      text-align: center;
      padding: 0 0.48rem;
      display: flex;
      justify-content: space-around;
      span {
        // width: 1.56rem;
        height: 0.5rem;
        line-height: 0.5rem;
        // background: #EE2532;
        border-radius: 0.25rem;
        text-align: center;
        color: #262626;    
        display: inline-block;    
        font-size: 0.3rem;
        vertical-align: middle;
        padding: 0 0.18rem;
        margin-bottom: 0.36rem;
        &.on {
          color: #fff;
          background: #EE2532;
        }
      }

    } 
  }
  .fixed-bar {
    position: fixed;
    z-index: 100;
    top: 0;
    width: 100%;
    height: 0.96rem;
    line-height: 0.96rem;
    background: #FFFFFF;
    padding-left: 0.56rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    span {
      color: #262626;
      font-size: 0.3rem;
      margin-right:0.4rem;
      height: 0.48rem;
      line-height: 0.48rem;
      &.on {
        color: #EE2532;
        border-bottom: 2px solid #EE2532;
      }
    }
  }
  .loadmore-box {
    padding-bottom: 1rem;
  }
  .b-coupon {
    position: fixed;
    bottom: 2rem;
    background: #000;
    color:#fff;
    right: .4rem;
    width: 1.72rem;
    height: 1.38rem;
    background: url('../image/coupon-small.png') no-repeat; 
    background-size: 100% 100%;  
    .coupon-price {
      font-size: .28rem;
      color: #8F5426;
      margin: 0 auto;
      display: block;
      text-align: center;
      margin-top: .18rem;
    }
    .coupon-time {
      display: block;
      text-align: center;
      font-size: .24rem;
      color: #FFFFFF;
      margin-top: .1rem;
    }
  }
}
</style>
